import { MapIcon } from '@/types/canvas';
import type { MapIcon as MapIconType } from '@/lib/api';

/**
 * Získá barvu ikony s jednotnou logikou napříč aplikací
 * Používá default barvu "black" (#000000) pokud ikona nemá vlastní barvu
 * @param icon - MapIcon objekt z frontend state
 * @param _iconData - MapIconType objekt ze Supabase (může být null, už se nepoužívá pro barvu)
 * @returns Hex barva ikony, vždy vrátí validní barvu (defaultně "black")
 */
export function getIconColor(
  icon: MapIcon,
  _iconData: MapIconType | null
): string {
  // Pokud má ikona vlastní barvu a je validní, použij ji
  if (icon.color !== undefined && icon.color !== null && icon.color !== '') {
    // Zkusit normalizovat barvu, pokud není validní
    const normalized = normalizeHexColor(icon.color);
    if (normalized) {
      return normalized;
    }
    // Pokud normalizace selže, ale barva projde validací, použít ji
    if (validateHexColor(icon.color)) {
      return icon.color;
    }
  }

  // Default barva je "black"
  return '#000000';
}

/**
 * Validuje hex barvu (#rrggbb nebo #rgb formát)
 * @param color - Hex barva k validaci
 * @returns true pokud je barva validní, jinak false
 */
export function validateHexColor(color: string): boolean {
  if (!color || typeof color !== 'string') {
    return false;
  }
  
  // Podporuj formát #rrggbb nebo #rgb
  return /^#[0-9A-F]{6}$/i.test(color) || /^#[0-9A-F]{3}$/i.test(color);
}

/**
 * Normalizuje hex barvu - přidá # pokud chybí, převede na 6-místný formát
 * @param color - Hex barva k normalizaci
 * @returns Normalizovaná hex barva nebo null pokud není validní
 */
export function normalizeHexColor(color: string): string | null {
  if (!color || typeof color !== 'string') {
    return null;
  }

  let normalized = color.trim();

  // Přidat # pokud chybí
  if (!normalized.startsWith('#')) {
    normalized = '#' + normalized;
  }

  // Pokud je 3-místný formát (#rgb), převede na 6-místný (#rrggbb)
  if (/^#[0-9A-F]{3}$/i.test(normalized)) {
    const r = normalized[1];
    const g = normalized[2];
    const b = normalized[3];
    normalized = `#${r}${r}${g}${g}${b}${b}`;
  }

  // Validovat výsledek
  if (validateHexColor(normalized)) {
    return normalized.toUpperCase();
  }

  return null;
}












